/** 与 extraParams / composer 等本地偏好键并列的命名空间 */
export const IMAGE_GEN_PREFS_STORAGE_KEY = 'glyphicai-create-image-prefs' as const

const SCHEMA_VERSION = 1

export type StoredImageGenPrefs = {
  platformId: string
  modelId: string
}

type PersistedPayload = StoredImageGenPrefs & { v: number }

export function readStoredImageGenPrefs(): StoredImageGenPrefs | null {
  try {
    const raw = localStorage.getItem(IMAGE_GEN_PREFS_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    if (typeof parsed !== 'object' || parsed === null) return null
    const o = parsed as Record<string, unknown>
    const v = o.v
    if (v !== undefined && v !== SCHEMA_VERSION) return null
    const platformId = o.platformId
    const modelId = o.modelId
    if (typeof platformId !== 'string' || typeof modelId !== 'string') return null
    const p = platformId.trim()
    const m = modelId.trim()
    if (!p || !m) return null
    return { platformId: p, modelId: m }
  } catch {
    return null
  }
}

export function persistImageGenPrefs(prefs: StoredImageGenPrefs): void {
  try {
    const body: PersistedPayload = { v: SCHEMA_VERSION, ...prefs }
    localStorage.setItem(IMAGE_GEN_PREFS_STORAGE_KEY, JSON.stringify(body))
  } catch {
    /* ignore */
  }
}
